export class StringKeyValue{
    Key: string;
    Value: string;
}